import React from 'react';

export function ConditionalLayer({ isShown, children }) {
	if (isShown) {
		// eslint-disable-next-line react/jsx-no-useless-fragment
		return <>{children}</>;
	}
	return null;
}
